import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import {
  APQueryOptions,
  SHORT_STALE_TIME,
  useAPQuery,
} from "../../providers/APQueryProvider";
import { Quote } from "../../types/Quote";

export const getQuote = (quoteId: string, options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled, defaultOnMutateError } = useAPQuery();

  return useQuery({
    queryKey: ["quote", quoteId],
    queryFn: (): Promise<Quote> => {
      return fetchWithAuth<Quote>("getQuote", quoteId);
    },
    staleTime: SHORT_STALE_TIME,
    refetchOnMount: options.useCached ? true : "always",
    enabled: isQueryEnabled(options),
    onError: defaultOnMutateError(options),
  });
};
